import { render, staticRenderFns } from "./OtherVehicle.vue?vue&type=template&id=f67e6468&"
import script from "./OtherVehicle.vue?vue&type=script&lang=ts&"
export * from "./OtherVehicle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports